import { render, staticRenderFns } from "./mem_inside_parts.vue?vue&type=template&id=163182d8&scoped=true&"
import script from "./mem_inside_parts.vue?vue&type=script&lang=js&"
export * from "./mem_inside_parts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163182d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('163182d8')) {
      api.createRecord('163182d8', component.options)
    } else {
      api.reload('163182d8', component.options)
    }
    module.hot.accept("./mem_inside_parts.vue?vue&type=template&id=163182d8&scoped=true&", function () {
      api.rerender('163182d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/parts/mem_inside_parts.vue"
export default component.exports